import React from 'react';
import styles from "./StockMonitoringDetails.module.scss";
import { useNavigate } from 'react-router-dom';
import DynamicTableFilters from '../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import StatusBadge from '../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';
import { inventoryLevelsTableData, stockMonitoringTableData } from '../../../../views/AdminPortal/dummyData';
import BlueBadge from '../../../common/AdminCommonComponents/BlueBadge/BlueBadge';
import ActionBtn from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionBtn';

const StockMonitoringDetails = () => {
    const navigate = useNavigate();

    const lowOptions = [
        { label: "View detail", action: () => navigate('/ordermanagement/orderfulfillment/inventorydetail') },
        { label: "Deactivate Product", action: () => console.log("Deactivate Product") },
        { label: "Notify Seller", action: () => console.log("Notify Seller") },
    ];

    const ampleOptions = [
        { label: "View detail", action: () => navigate('/ordermanagement/orderfulfillment/inventorydetail') },
        { label: "Activate Product", action: () => console.log("Activate Product") },
        { label: "Notify Seller", action: () => console.log("Notify Seller") },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Product ID",
            selector: (row) => row.productId,
            center: "true",
            width: "150px",
        },
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
        },
        {
            name: "Category",
            selector: (row) => row.category,
            center: "true",
        },
        {
            name: "Seller ID",
            selector: (row) => row.sellerId,
            center: "true",
        },
        {
            name: "Current Stock",
            cell: (row) => <BlueBadge>{row.currentStock}</BlueBadge>,
            center: "true",
        },
        {
            name: "Low Stock Threshold",
            selector: (row) => row.lowStockThreshold,
            center: "true",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            center: "true",
        },
        {
            name: "Restock Needed",
            selector: (row) => row.restockNeeded,
            center: "true",
        },
        {
            name: "Action",
            cell: (row) => <ActionBtn>Notify Seller</ActionBtn>,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters apply={false} componentName={"Stock Monitoring"}  onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={stockMonitoringTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default StockMonitoringDetails;